import React from 'react'
import css from './aboutUs.module.css'
import Section1 from './section1/Section1'
import Section2 from './section2/Section2'
import Section3 from './section3/Section3'
import Section4 from './section4/Section4'
import Section5 from './section5/Section5'
import Section6 from './section6/Section6'
import FreeTrailCard from './../home/section7/FreeTrailCard';

const AboutUs = () => {
  return (
    <div>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <div style={{padding: '2rem 1rem'}}>
        <FreeTrailCard />
      </div>
    </div>
  )
}

export default AboutUs